const LOG_LEVELS = {
  DEBUG: {
    level: 1,
    name: 'DEBUG',
  },
  INFO: {
    level: 2,
    name: 'INFO',
  },
  WARN: {
    level: 3,
    name: 'WARN',
  },
  ERROR: {
    level: 4,
    name: 'ERROR',
  },
  FATAL: {
    level: 5,
    name: 'FATAL',
  },
  OFF: {
    level: 0,
    name: 'OFF',
  },
};

export { LOG_LEVELS };
